<script>
    import FrameworkReference from "../../Models/frameworkReferenceModel";
    import SortableTable from '../SortableTable.svelte';
    import Loader from '../Loader.svelte';
    import { addFormModal } from '../../Forms/ModalFormManager.svelte';
    import { forms } from '../../lib/forms';
    import { notifier } from '@beyonk/svelte-notifications';
    import { confirm } from '../Confirmation.svelte';

    export let params;

    let table_fields = [
        {
            field: "name",
            label: "Field Name"
        },
        {
            field: "type",
            label: "Field Type"
        },
        {
            field: "required",
            label: "Required",
            type: "checkbox"
        },
        {
            field: "default_hidden",
            label: "Hide by Default",
            type: 'checkbox'
        }
    ]

    function addField() {
        addFormModal({
            fields: forms['customForm'],
        }).then((data) => {
            if (data.name == "name") {
                notifier.danger("name is a reserved field");
            } else if (data.name == "details") {
                notifier.danger("details is a reserved field");
            }else {
                $framework.fields.addChild(data).then(() => notifier.success("Field Added"));
            }
        }).catch(() => {});
    }

    function editField(field) {
        addFormModal({
            fields: forms['customForm'],
            data: field.details
        }).then(formData => {
            field.save(formData).then(() => notifier.success("Field Updated"));
        })
    }

    function deleteField(field) {
        confirm(`Are you sure you want to delete "${field.details.name}"?`).then(() => {
            field.delete().then(() => notifier.success("Field Deleted"))
        })
    }

    function saveAutocomplete(evt) {
        let details = JSON.parse(JSON.stringify($framework.details));
        let form = evt.target;

        let autocomplete = form['autocomplete'].value;

        details.autocomplete = autocomplete;

        $framework.save(details).then(() => notifier.success("Autocomplete Template saved"));
    }

    function moveField(evt) {
        let fields = [...$framework.fields];

        if (evt.detail.newIndex == evt.detail.oldIndex) return;

        let newIndex = evt.detail.newIndex;
        let oldIndex = evt.detail.oldIndex;

        let after, before;
        if (newIndex == 0) {
            before = fields[1];
        } else if (newIndex == fields.length) {
            after = fields[newIndex];
        } else {
            if (newIndex < oldIndex) {
                after = fields[newIndex - 1];
                before = fields[newIndex];
            } else {
                after = fields[newIndex];
                before = fields[newIndex + 1];
            }
        }

        $framework.fields.moveChild(fields[oldIndex], after, before);
    }

    $: framework = FrameworkReference.getStore(params.id);
</script>

<Loader loading={!$framework}>
    <div class="container is-fluid">
        <h1 class="title is-1">
            {$framework.details.name}
            <a href="#/frameworkReference" class="button is-pulled-right">Close</a>
        </h1>

        <div class="section">
            <h2 class="title is-2">Fields</h2>
            <SortableTable sortFields={table_fields} tableData={[...$framework.fields]} showHideFields={false} ORM={true} paged={false} sortable={true} on:sortEnd={moveField}>
                <svelte:fragment slot="topRow">
                    <tr>
                        <td>Reference Number (name)</td>
                        <td>text</td>
                        <td class="is-v-centered is-h-centered"><input type="checkbox"  on:click|preventDefault checked="true"></td>
                        <td class="is-v-centered is-h-centered"><input type="checkbox"  on:click|preventDefault></td>
                        <td></td>
                    </tr>
                </svelte:fragment>
                <div slot="footerActions">
                    <div class="buttons is-right">
                        <button class="button is-success" on:click={addField}>Add Field</button>
                    </div>
                </div>
                <div slot="rowActions" let:row={field}>
                    <span class="button is-info" on:click={() => editField(field)}>Edit</span>
                    <span class="button is-danger" on:click={() => deleteField(field)}>Delete</span>
                </div>
            </SortableTable>
        </div>

        <div class="section">
            <h2 class="title is-2">Autocomplete Template</h2>
            <form on:submit|preventDefault ={saveAutocomplete}>
                <div class="field">
                    <input type="text" class="input is-large is-fullwidth" name="autocomplete" value={ $framework.details.autocomplete || "" }>
                </div>
                <div class="buttons is-right">
                    <button class="button is-success">Save Autocomplete Template</button>
                </div>
            </form>
        </div>
    </div>
</Loader>
